import { Card, CardActionArea, CardContent, CardMedia, Typography } from "@mui/material";
import { useState } from "react";
import { IProdutoPedido } from "../../../pedidos/interface/IProdutoPedido";
import { IProduto } from "../../interfaces/IProduto";
import { useMoeda } from "../../../core/hooks/useMoeda";
import { useLetras } from "../../../core/hooks/useLetras";
import { DrawerComboOperacao } from "../DrawerComboOperacao";

interface CardComboOperacaoProps {
    produto: IProduto;
    adicionarProdutosCombo: (produtos: IProdutoPedido[]) => void;
    modoTeclado?: boolean;
    isSelecionado?: boolean;
}

export const CardComboOperacao = ({ produto, adicionarProdutosCombo, modoTeclado = false, isSelecionado = false }: CardComboOperacaoProps) => {
    const [open, setOpen] = useState(false);
    const { real } = useMoeda();
    const { maiusculas } = useLetras();

    return (
        <>
            <Card
                sx={{
                    maxWidth: 300,
                    height: 250,
                    ...(isSelecionado && {
                        border: '3px solid',
                        borderColor: 'primary.main',
                        boxShadow: '0 0 0 2px rgba(25, 118, 210, 0.2)',
                        transform: 'scale(1.02)',
                        transition: 'all 0.2s ease-in-out'
                    })
                }}
                variant="outlined"
                onClick={() => setOpen(true)}
            >
                <CardActionArea sx={{ height: "100%", width: "100%" }}>
                    {produto.imagens?.length ? (
                        <CardMedia
                            component="img"
                            height="140px"
                            image={produto.imagens[0].url}
                            sx={{ objectFit: "cover" }}
                            alt="Combo"
                        />
                    ) : (
                        <CardMedia
                            component="img"
                            height="140px"
                            image={`${process.env.PUBLIC_URL}/images/produtos/combo.png`}
                            sx={{ objectFit: "contain" }}
                            alt="Combo"
                        />
                    )}
                    <CardContent sx={{ height: "100%" }}>
                        <Typography gutterBottom variant="subtitle2" fontWeight="bold" component="div">
                            {maiusculas(produto.descricao, 25)}
                        </Typography>
                        <Typography gutterBottom variant="body1" component="div">
                            {real(produto.preco)}
                        </Typography>
                    </CardContent>
                </CardActionArea>
            </Card>
            <DrawerComboOperacao
                open={open}
                toggleDrawer={() => setOpen(false)}
                produto={produto}
                adicionarProdutosCombo={adicionarProdutosCombo}
            />
        </>
    );
};
